import { render, staticRenderFns } from "./tvspotrate.vue?vue&type=template&id=4854563a"
import script from "./tvspotrate.vue?vue&type=script&lang=js"
export * from "./tvspotrate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports